export enum ActionTypes {
    FetchSpotlight = "FETCH_SPOTLIGHT",
    FetchSpotlightPending = "FETCH_SPOTLIGHT_PENDING",
    FetchSpotlightRejected = "FETCH_SPOTLIGHT_REJECTED",
    FetchSpotlightFulfilled = "FETCH_SPOTLIGHT_FULFILLED",
    RemoveSpotlightItem = "REMOVE_SPOTLIGHT_ITEM",
}
